import React from 'react';
import {
  Box,
  Typography,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  useTheme,
} from '@mui/material';
import { Container, Row, Col } from 'reactstrap';
import {
  faClock,
  faClipboardCheck,
  faUserShield,
  faInfoCircle,
} from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { PrimaryButton } from '../common/Buttons';
import Net30Image from '../images/net30-illustration.png'; // PNG limpio
import './style.css';

function Net30Section({ id }) {
  const theme = useTheme();

  return (
    <section className="net30-section" id={id || "request-net30"}>
      <Container>
        <Row className="align-items-center">
          <Col md="6" className="mb-4 mb-md-0">
            <Box>
              <Typography variant="h4" fontWeight="bold" gutterBottom>
                NET 30: Launch now, pay later.
              </Typography>

              <Typography variant="subtitle1" color="text.secondary" paragraph>
                We understand cash flow matters. That’s why we offer validated businesses the ability to use our hosting today and pay in 30 days with no interest.
              </Typography>

              <Typography variant="subtitle2" fontWeight="bold" gutterBottom>
                How it works:
              </Typography>

              <List disablePadding>
                <ListItem>
                  <ListItemIcon sx={{ minWidth: 32 }}>
                    <FontAwesomeIcon icon={faClock} color={theme.palette.primary.main} />
                  </ListItemIcon>
                  <ListItemText primary="Fast business validation (24–48h)" />
                </ListItem>
                <ListItem>
                  <ListItemIcon sx={{ minWidth: 32 }}>
                    <FontAwesomeIcon icon={faClipboardCheck} color={theme.palette.primary.main} />
                  </ListItemIcon>
                  <ListItemText primary="Signed contract or payment agreement" />
                </ListItem>
                <ListItem>
                  <ListItemIcon sx={{ minWidth: 32 }}>
                    <FontAwesomeIcon icon={faUserShield} color={theme.palette.primary.main} />
                  </ListItemIcon>
                  <ListItemText primary="Available for Pro, Commerce, and Custom plans" />
                </ListItem>
              </List>

              <Box mt={2} display="flex" alignItems="flex-start">
                <FontAwesomeIcon
                  icon={faInfoCircle}
                  style={{ marginRight: 10, marginTop: 4 }}
                />
                <Typography variant="body2">
                  Applications must be submitted by an authorized company officer and completed in one sitting.
                </Typography>
              </Box>

              <Box mt={3}>
                <PrimaryButton href="/Net-30">
                  📩 Request NET 30
                </PrimaryButton>
              </Box>
            </Box>
          </Col>

          <Col md="6">
            <Box
              component="img"
              src={Net30Image}
              alt="NET 30 Illustration"
              className="net30-image"
              sx={{ width: '100%', borderRadius: 3 }}
            />
          </Col>
        </Row>
      </Container>
    </section>
  );
}

export default Net30Section;
